import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.CONFIRM_USER}/:email/:code`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ConfirmUserContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'confirmUser', reducer: reducer.default })

    cb(null, module.default)
  }
})
